import React, { useEffect, useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'

type FolderNameDialogProps = {
  open: boolean
  mode: 'create' | 'rename'
  initialName?: string
  onClose: () => void
  onSubmit: (name: string) => void
}

function FolderNameDialog({
  open,
  mode,
  initialName = '',
  onClose,
  onSubmit,
}: FolderNameDialogProps) {
  const [name, setName] = useState(initialName)

  useEffect(() => {
    if (open) setName(initialName)
  }, [open, initialName])

  const trimmedName = name.trim()

  function handleSubmit() {
    if (!trimmedName) return
    onSubmit(trimmedName)
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{mode === 'create' ? 'New Folder' : 'Rename Folder'}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label="Folder name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleSubmit()
          }}
          sx={{
            '& .MuiInputLabel-root': { color: 'text.secondary' },
            '& .MuiInputLabel-root.Mui-focused': { color: 'text.primary' },
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} disabled={!trimmedName} variant="contained">
          {mode === 'create' ? 'Create' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default FolderNameDialog
